import React from 'react'
import Link from 'gatsby-link'
import YouTube from 'react-youtube'
import {Gmaps, Marker, InfoWindow, Circle} from 'react-gmaps';
import '../style/home.scss'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import Wave from '../images/wave.svg'
import Surfer from '../images/surfer.svg'
import Board from '../images/board.svg'
import Van from '../images/van.png'
import Van2 from '../images/van2.png'
import Miniature1 from '../images/miniature1.png'
import Miniature2 from '../images/miniature2.png'
import Miniature3 from '../images/miniature3.png'
import Miniature4 from '../images/miniature4.png'
import UnderlineOrange from '../images/underline_orange.svg'
import UnderlineGreen from '../images/underline_green.svg'
import Layout1 from '../images/layout1.png'
import Layout2 from '../images/layout2.png'
import Layout3 from '../images/layout3.png'
import Layout4 from '../images/layout4.png'
import Max from '../images/max.png'
import Logo from '../images/white-orange.png'
import ImageBackground from '../images/image-background.png'
import SchoolPrices from '../prices/surf-school-prices.pdf';
import RentalPrices from '../prices/rental-prices.pdf';
import PowliMaps from '../images/powli-maps.png';

import Fade from 'react-reveal/Fade'; // Importing Zoom effect
import Slide from 'react-reveal/Slide';
import Flip from 'react-reveal/Flip';

class IndexPage extends React.Component {
  render() {
    const videoOptions = {
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 1,
        controls: 1,
        loop: 1,
        showinfo: 1,
        modestbranding: 1,
        rel: 0,
        mute: 1
      }
    };
    const videoOptions2 = {
      playerVars: { // https://developers.google.com/youtube/player_parameters
        autoplay: 0,
        controls: 1,
        loop: 0,
        showinfo: 0,
        modestbranding: 1,
        rel: 1
      }
    };
    const coords = {
      lat: 16.422295,
      lng: -61.533254
    };

    const params = {
      v: '3.exp',
      key: 'AIzaSyA8v4LfZIsueHQb8hxZoNq3mj1c5pbiC30'
    };
    const imageUrlLayout2 = require(`../images/layout2.png`)
    const imageUrlMiniature1 = require(`../images/miniature1.png`)
    const imageUrlMiniature2 = require(`../images/miniature2.png`)
    const imageUrlMiniature3 = require(`../images/miniature3.png`)
    const imageUrlMiniature4 = require(`../images/miniature4.png`)

    return (
      <div className="page-landing">
            <Navbar/>
            <div className="video-background">
              <div className="video-foreground">
                <YouTube videoId="z7BtvZQZKNA" opts={videoOptions} className="video-iframe" onReady={this._onReady} onEnd={this._onEnd}/>
              </div>
            </div>
            <div className="image-background">
              <img className="background" src={ImageBackground} alt="background"></img>
            </div>
            <a className="phone-call" href="tel:0033695335509">
              <div className="icon-phone phone"></div>
              <div className="phone-number">+33 695 335 509</div>
            </a>
            <div className="first-screen-container">
              <Fade duration={3000} delay={500}>
                <div className="title-container">
                  <div className="title">APPRENEZ LE SURF EN GUADELOUPE</div>
                </div>
              </Fade>
              <temp></temp>
              <Fade duration={3000} delay={1000}>
                <button className="button-book">
                  <a href="tel:0033695335509">
                  <div className="icon-more more"></div>
                  <div className="book">RESERVER</div>
                  <img className="wave" src={Wave} alt="wave"></img>
                  </a>
                </button>
              </Fade>
              <img className="van" src={Van} alt="van"></img>
            </div>
            <div className="second-screen-container">
              <h1>
                <div>UN CADRE EXCEPTIONNEL</div>
                <Fade duration={1500} delay={500}>
                  <img className="underline" src={UnderlineOrange} alt="underline"></img>
                </Fade>
              </h1>
              <div className="core-container">
                <div className="side-container">
                  <div className="row">
                    <Fade duration={1500} delay={500} left="left">
                      <div className="miniature-container" style={{
                          backgroundImage: `url(${imageUrlMiniature1})`
                        }}>
                        <div className="miniature-description">UNE PLAGE DE REVE</div>
                      </div>
                    </Fade>
                    <Fade duration={1500} delay={500} right="right">
                      <div className="miniature-container" style={{
                          backgroundImage: `url(${imageUrlMiniature2})`
                        }}>
                        <div className="miniature-description">TEMPERATURES IDEALES</div>
                      </div>
                    </Fade>
                  </div>

                  <div className="row">
                    <Fade duration={1500} delay={500} left="left">
                      <div className="miniature-container" style={{
                          backgroundImage: `url(${imageUrlMiniature3})`
                        }}>
                        <div className="miniature-description">DES VAGUES PARFAITES</div>
                      </div>
                    </Fade>
                    <Fade duration={1500} delay={500} right="right">
                      <div className="miniature-container" style={{
                          backgroundImage: `url(${imageUrlMiniature4})`
                        }}>
                        <div className="miniature-description">FACILE D'ACCES ET PARKING GRATUIT</div>
                      </div>
                    </Fade>
                  </div>
                </div>
                <div className="side-container">
                  <img className="gmaps" src={PowliMaps}/>
                  <div className="maps-description">PORT-LOUIS, GUADELOUPE</div>
                </div>
                <img className="layout1" src={Layout1} alt="layout"></img>
              </div>
            </div>
            <div className="third-screen-container">
              <h1 className="white">
                <div>ECOLE DE SURF MAX MARIANNE</div>
                <Fade duration={1500} delay={500}>
                  <img className="underline" src={UnderlineGreen} alt="underline"></img>
                </Fade>
              </h1>

              <div className="core-container">
                <Fade duration={3000} delay={500}>
                  <img className="max" src={Max} alt="max"></img>
                </Fade>
                <Fade duration={3000} delay={1000}>
                  <div className="layout2-container" style={{
                      backgroundImage: `url(${imageUrlLayout2})`
                    }}>
                    <h2>
                      <div>MAX MARIANNE</div>
                      <img className="underline" src={UnderlineGreen} alt="underline"></img>
                    </h2>
                    <div className="resume-container">
                      <div className="resume-row">ANCIEN BODYBOARDER PRO</div>
                      <div className="resume-row">25 ANS D'EXPERIENCE</div>
                      <div className="resume-row">DIPLOME D'ETAT</div>
                      <div className="resume-row">coach certifie en développement personnel</div>
                      <div className="resume-row">Pedagogie et bonne humeur</div>
                    </div>
                  </div>
                </Fade>
              </div>
              <img className="van2" src={Van2} alt="van"></img>
            </div>

            <div className="fourth-screen-container">
              <h1>
                <div>PRESTATIONS</div>
                <Fade duration={1500} delay={500}>
                  <img className="underline" src={UnderlineOrange} alt="underline"></img>
                </Fade>
              </h1>

              <div className="core">
                <Fade duration={3000} delay={500}>
                <div className="service-container">
                  <div className="service-header">
                    <div>COURS</div>
                  </div>

                  <div className="service-title">SURF & BODYBOARD</div>
                  <div className="service-subtitle">COURS PARTICULIERS</div>
                  <div className="service-subtitle">COURS COLLECTIFS</div>
                  <div className="service-title inline">STAND-UP PADDLE</div>
                  <div className="service-subtitle">INITIATION</div>
                  <div className="service-subtitle">FAMILLE</div>
                  <div className="service-subtitle">RANDONNEE</div>
                  <temp></temp>
                  <button className="button-book">
                    <a href = {SchoolPrices} target = "_blank">
                    <div>TARIFS</div>
                    <img className="button-icon" src={Surfer} alt="surfer"></img>
                    </a>
                  </button>
                </div>
              </Fade>
              <Fade duration={3000} delay={1000}>
                <div className="service-container orange">
                  <div className="service-header">
                    <div>LOCATION</div>
                  </div>

                  <div className="service-title first">STAND UP PADDLE</div>
                  <div className="service-title">SURF BIC</div>
                  <div className="service-title">LONGBOARD</div>
                  <div className="service-title">SURF RESINE</div>
                  <div className="service-title">BODYBOARD</div>
                  <div className="service-title">PALMES</div>
                  <temp></temp>
                  <button className="button-book">
                    <a href = {RentalPrices} target = "_blank">
                    <div>TARIFS</div>
                    <img className="button-icon" src={Board} alt="board"></img>
                    </a>
                  </button>
                </div>
              </Fade>
              </div>
              <img className="layout3" src={Layout3} alt="layout"></img>
            </div>
            <div className="galery-screen-container">
              <h1 className="white">
                <div>GALERIE</div>
                <Fade duration={1500} delay={500}>
                  <img className="underline" src={UnderlineGreen} alt="underline"></img>
                </Fade>
              </h1>
              <div className="core">
                <YouTube className="video-galery" videoId="1sHpCX97lyg" opts={videoOptions2} onReady={this.onReady} onEnd={this.onEnd}/>
                <img className="logo-image" src={Logo} alt="logo"></img>
              </div>
            </div>
            <Footer/>
          </div>
    );
  }

  _onReady(event) {
    // access to player in all event handlers via event.target
    event.target.playVideo();
    event.target.mute();
  }
  onReady(event) {
    // access to player in all event handlers via event.target
  }
  onEnd(event) {
    event.target.playVideo();
  }
  _onEnd(event) {
    event.target.playVideo();
  }
  onMapCreated(map) {
    map.setOptions({disableDefaultUI: true});
  }

  onDragEnd(e) {
    console.log('onDragEnd', e);
  }

  onCloseClick() {
    console.log('onCloseClick');
  }

  onClick(e) {
    console.log('onClick', e);
  }
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js